require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./photos-professional-m-g-dms.json") })
        }
      }, "path---photos-professional-m-g-dms");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---photos-professional-m-g-dms!./.cache/json/photos-professional-m-g-dms.json
// module id = 831
// module chunks = 231608221292675